export const conversationMetrics = [
    {
        "timestamp": "2024-03",
        "sentiment_score": 0.6812,
        "dominant_emotion": "sadness",
        "emotion_score": 0.9415,
        "information_entropy": 0.2006,
        "lexical_diversity": 0.0,
        "readability_score": 100.24,
        "topic": 2,
        "semantic_similarity": 0.1544,
        "user": 14
    }, {
        "timestamp": "2024-03",
        "sentiment_score": 0.7234,
        "dominant_emotion": "joy",
        "emotion_score": 0.8876,
        "information_entropy": 0.2453,
        "lexical_diversity": 0.12,
        "readability_score": 95.67,
        "topic": 1,
        "semantic_similarity": 0.2231,
        "user": 14
    }, {
        "timestamp": "2024-03",
        "sentiment_score": 0.4567,
        "dominant_emotion": "fear",
        "emotion_score": 0.7654,
        "information_entropy": 0.1876,
        "lexical_diversity": 0.08,
        "readability_score": 88.92,
        "topic": 3,
        "semantic_similarity": 0.3112,
        "user": 14
    }, {
        "timestamp": "2024-05",
        "sentiment_score": 0.8234,
        "dominant_emotion": "joy",
        "emotion_score": 0.9123,
        "information_entropy": 0.2789,
        "lexical_diversity": 0.15,
        "readability_score": 105.45,
        "topic": 2,
        "semantic_similarity": 0.1876,
        "user": 14
    }, {
        "timestamp": "2024-05",
        "sentiment_score": 0.3456,
        "dominant_emotion": "anger",
        "emotion_score": 0.8765,
        "information_entropy": 0.1543,
        "lexical_diversity": 0.05,
        "readability_score": 92.31,
        "topic": 4,
        "semantic_similarity": 0.2543,
        "user": 14
    }, {
        "timestamp": "2024-04",
        "sentiment_score": 0.5678,
        "dominant_emotion": "surprise",
        "emotion_score": 0.7123,
        "information_entropy": 0.2234,
        "lexical_diversity": 0.11,
        "readability_score": 97.86,
        "topic": 1,
        "semantic_similarity": 0.1987,
        "user": 14
    }, {
        "timestamp": "2024-06",
        "sentiment_score": 0.7890,
        "dominant_emotion": "joy",
        "emotion_score": 0.8543,
        "information_entropy": 0.2567,
        "lexical_diversity": 0.14,
        "readability_score": 103.12,
        "topic": 2,
        "semantic_similarity": 0.2765,
        "user": 14
    }, {
        "timestamp": "2024-06",
        "sentiment_score": 0.4321,
        "dominant_emotion": "disgust",
        "emotion_score": 0.6789,
        "information_entropy": 0.1765,
        "lexical_diversity": 0.07,
        "readability_score": 91.45,
        "topic": 3,
        "semantic_similarity": 0.3234,
        "user": 14
    }, {
        "timestamp": "2024-07",
        "sentiment_score": 0.6543,
        "dominant_emotion": "sadness",
        "emotion_score": 0.8234,
        "information_entropy": 0.2123,
        "lexical_diversity": 0.09,
        "readability_score": 98.76,
        "topic": 2,
        "semantic_similarity": 0.1654,
        "user": 14
    }, {
        "timestamp": "2024-10",
        "sentiment_score": 0.5432,
        "dominant_emotion": "surprise",
        "emotion_score": 0.7456,
        "information_entropy": 0.1987,
        "lexical_diversity": 0.10,
        "readability_score": 94.23,
        "topic": 1,
        "semantic_similarity": 0.2876,
        "user": 14
    }
]

export const conversationFlow = [
    {
        "id": 9,
        "avg_message_length": 16.4,
        "turn_taking_rate": 0.0012,
        "question_frequency": 0.0,
        "command_frequency": 0.0,
        // "timestamp": "2024-09-25T11:37:43.354226Z",
        "timestamp": "2024-03",
        "user_id": 14,
        "conversation_id": "7bd97676-418f-4d5d-9dbf-076119876474"
    }, {
        "id": 10,
        "avg_message_length": 22.7,
        "turn_taking_rate": 0.0018,
        "question_frequency": 0.15,
        "command_frequency": 0.05,
        "timestamp": "2024-03",
        "user_id": 14,
        "conversation_id": "9cd45678-512e-4a6b-8ef9-123456789012"
    }, {
        "id": 11,
        "avg_message_length": 18.9,
        "turn_taking_rate": 0.0015,
        "question_frequency": 0.08,
        "command_frequency": 0.02,
        "timestamp": "2024-05",
        "user_id": 14,
        "conversation_id": "3ef56789-623f-4b7c-9fg0-234567890123"
    }, {
        "id": 12,
        "avg_message_length": 25.3,
        "turn_taking_rate": 0.0021,
        "question_frequency": 0.22,
        "command_frequency": 0.07,
        "timestamp": "2024-02",
        "user_id": 14,
        "conversation_id": "4gh67890-734g-4c8d-0hi1-345678901234"
    }, {
        "id": 13,
        "avg_message_length": 19.8,
        "turn_taking_rate": 0.0014,
        "question_frequency": 0.12,
        "command_frequency": 0.03,
        "timestamp": "2024-06",
        "user_id": 14,
        "conversation_id": "5hi78901-845h-4d9e-1ij2-456789012345"
    }, {
        "id": 14,
        "avg_message_length": 21.5,
        "turn_taking_rate": 0.0017,
        "question_frequency": 0.18,
        "command_frequency": 0.06,
        "timestamp": "2024-06",
        "user_id": 14,
        "conversation_id": "6ij89012-956i-4e0f-2jk3-567890123456"
    }, {
        "id": 15,
        "avg_message_length": 17.2,
        "turn_taking_rate": 0.0013,
        "question_frequency": 0.05,
        "command_frequency": 0.01,
        "timestamp": "2024-02",
        "user_id": 14,
        "conversation_id": "7jk90123-067j-4f1g-3kl4-678901234567"
    }, {
        "id": 16,
        "avg_message_length": 24.1,
        "turn_taking_rate": 0.0020,
        "question_frequency": 0.25,
        "command_frequency": 0.08,
        "timestamp": "2024-03",
        "user_id": 14,
        "conversation_id": "8kl01234-178k-4g2h-4lm5-789012345678"
    }, {
        "id": 17,
        "avg_message_length": 20.6,
        "turn_taking_rate": 0.0016,
        "question_frequency": 0.15,
        "command_frequency": 0.04,
        "timestamp": "2024-02",
        "user_id": 14,
        "conversation_id": "9lm12345-289l-4h3i-5mn6-890123456789"
    }, {
        "id": 18,
        "avg_message_length": 23.8,
        "turn_taking_rate": 0.0019,
        "question_frequency": 0.20,
        "command_frequency": 0.07,
        "timestamp": "2024-07",
        "user_id": 14,
        "conversation_id": "0mn23456-390m-4i4j-6no7-901234567890"
    }
]

export const lsmData = [
    {
        "user_id": 1,
        "score": 15,
        "timestamp": "January",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 1,
        "score": 12,
        "timestamp": "February",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 1,
        "score": 34,
        "timestamp": "March",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 1,
        "score": 19,
        "timestamp": "April",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 1,
        "score": 52,
        "timestamp": "May",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }
]

export const similarityScores = [
    {
        "user": "User 14",
        "similarity_score": 0.74
    }, {
        "user": "User 23",
        "similarity_score": 0.68
    }, {
        "user": "User 37",
        "similarity_score": 0.82
    }, {
        "user": "User 45",
        "similarity_score": 0.59
    }, {
        "user": "User 51",
        "similarity_score": 0.77
    }, {
        "user": "User 62",
        "similarity_score": 0.71
    }, {
        "user": "User 78",
        "similarity_score": 0.65
    },
    // {     "user": "User 89",     "similarity_score": 0.88 }, {     "user": "User
    // 9",     "similarity_score": 0.63 }, {     "user": "User 96",
    // "similarity_score": 0.79 }
]

const psych_profiler = [
    {
        "id": 138,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 1,
        "total_assessments": 1,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.1,
        "last_updated": "2025-06-11T13:42:30.411459Z",
        "user": 2,
        "transcript": "485d7412-343e-4da2-9262-b3006f348c57",
        "timestamp": "2025-06"
    }, {
        "id": 139,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.5,
        "total_assessments": 2,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.12,
        "last_updated": "2025-06-11T13:42:30.421027Z",
        "user": 2,
        "transcript": "485d7412-343e-4da2-9262-b3006f348c57",
        "timestamp": "2025-06"
    }, {
        "id": 140,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.33,
        "total_assessments": 3,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.12,
        "last_updated": "2025-06-11T13:42:30.424726Z",
        "user": 2,
        "transcript": "0354426a-dc51-4af8-b608-cee564aec693",
        "timestamp": "2025-06"
    }, {
        "id": 141,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.25,
        "total_assessments": 4,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.11,
        "last_updated": "2025-06-11T13:42:30.428066Z",
        "user": 2,
        "transcript": "0354426a-dc51-4af8-b608-cee564aec693",
        "timestamp": "2025-06"
    }, {
        "id": 142,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.4,
        "total_assessments": 5,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.14,
        "last_updated": "2025-06-11T13:42:30.430819Z",
        "user": 2,
        "transcript": "0354426a-dc51-4af8-b608-cee564aec693",
        "timestamp": "2025-06"
    }, {
        "id": 143,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.33,
        "total_assessments": 6,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.11,
        "last_updated": "2025-06-11T13:42:30.433234Z",
        "user": 2,
        "transcript": "0354426a-dc51-4af8-b608-cee564aec693",
        "timestamp": "2025-06"
    }, {
        "id": 144,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.29,
        "total_assessments": 7,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.08,
        "last_updated": "2025-06-11T13:42:30.435872Z",
        "user": 2,
        "transcript": "a8d4bf76-989f-4a0f-b1b9-cca3b7eab94b",
        "timestamp": "2025-06"
    }, {
        "id": 145,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.25,
        "total_assessments": 8,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.09,
        "last_updated": "2025-06-11T13:42:30.441189Z",
        "user": 2,
        "transcript": "a8d4bf76-989f-4a0f-b1b9-cca3b7eab94b",
        "timestamp": "2025-06"
    }, {
        "id": 146,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.22,
        "total_assessments": 9,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.1,
        "last_updated": "2025-06-11T13:42:30.443876Z",
        "user": 2,
        "transcript": "a8d4bf76-989f-4a0f-b1b9-cca3b7eab94b",
        "timestamp": "2025-06"
    }, {
        "id": 147,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.3,
        "total_assessments": 10,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.12,
        "last_updated": "2025-06-11T13:42:30.446415Z",
        "user": 2,
        "transcript": "a8d4bf76-989f-4a0f-b1b9-cca3b7eab94b",
        "timestamp": "2025-06"
    }, {
        "id": 148,
        "most_likely_pairing": "Ne Hero - Si Inferior",
        "probability": 0.27,
        "total_assessments": 11,
        "strengths": "Confident in their ability to perceive the multitude and variance of perspecti" +
                "ves, uncertainties and possibilities, how they interrelate and what they imply" +
                ", Idea generation, seeing possibilities, or forming abstract connections",
        "challenges": "Insecure in their ability to discover, assign, create and associate meaning an" +
                "d consistency to the physical world, its impressions and effects and to create" +
                " and maintain reliable and comfortable systems and habits for daily physical l" +
                "ife, Detailed memory recall, maintaining routines, or practical application of" +
                " past experiences",
        "certainty": 0.13,
        "last_updated": "2025-06-11T13:42:30.448553Z",
        "user": 2,
        "transcript": "a8d4bf76-989f-4a0f-b1b9-cca3b7eab94b",
        "timestamp": "2025-06"
    }, {
        "id": 149,
        "most_likely_pairing": "Fe Hero - Ti Inferior",
        "probability": 0.33,
        "total_assessments": 12,
        "strengths": "Confident in their ability to maintain and strengthen social coherence for com" +
                "munal and mutual success, Social awareness, empathy, or creating harmony in gr" +
                "oups",
        "challenges": "Insecure in their ability to filter out falsehood, examine axioms and framewor" +
                "ks, discover and resolve contradictions and align oneself with truth, Logical " +
                "analysis, maintaining objectivity, or individual decision-making",
        "certainty": 0.15,
        "last_updated": "2025-06-11T13:42:30.450173Z",
        "user": 2,
        "transcript": "a8d4bf76-989f-4a0f-b1b9-cca3b7eab94b",
        "timestamp": "2025-06"
    }
]

const LSM = [
    {
        "user_id": 14,
        "category": 'Personal Pronouns',
        "score": 15,
        "timestamp": "2024-03",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 14,
        "category": 'Impersonal Pronouns',
        "score": 12,
        "timestamp": "2024-03",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 14,
        "category": 'Articles',
        "score": 34,
        "timestamp": "2024-02",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 14,
        "score": 19,
        "category": 'Prepositions',
        "timestamp": "2024-03",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }, {
        "user_id": 14,
        "category": 'Auxiliary Verbs',
        "score": 52,
        "timestamp": "2024-04",
        "conversation_id": "123sd-gthfh-g5b-ew321"
    }
]

export const sampleData = [
    {
        id: 1,
        name: "User A",
        psychometrics: {
            conversationMetrics,
            conversationFlow,
            psych_profiler,
            lsmScores: LSM
        }
    }
]
